module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/account/orders/orders.component.scss
// module id = ./src/app/components/account/orders/orders.component.scss
// module chunks = main